export default __webpack_public_path__ + "static/media/war3.51ccf6d4.png";